import { INIT } from './app';


const reducer = (state = [], action) => {
  switch (action.type) {
    case INIT: {
      const incoming = Array.isArray(action.payload && action.payload.bookings)
        ? action.payload.bookings
        : [];
      if (incoming.length > 0) return [...incoming];
      return state.length > 0 ? state : [];
    }
    default:
      return state;
  }
};

export default reducer;
